import CalcForm from './calcForm';

export default CalcForm;
